import type { FC } from 'react'
import { useScrollReset } from 'src/hooks/useScrollReset'

export const ScrollReset: FC = () => {
  useScrollReset()
  return null
}
